import React from "react";
import { useTheme, useMediaQuery, Box } from "@mui/material";
import { Images } from "../../../utils/Images";

const categories = [
  { id: 1, name: "Urgent", icon: Images.urgent },
  { id: 2, name: "Children", icon: Images.children },
  { id: 3, name: "Animals", icon: Images.animals },
  { id: 4, name: "Disability", icon: Images.disability },
  { id: 5, name: "Disaster Relief", icon: Images.disasterRelief },
  { id: 6, name: "Education", icon: Images.education },
  { id: 7, name: "Elderly", icon: Images.elderly },
  { id: 8, name: "Faith", icon: Images.faith },
  { id: 9, name: "Hunger", icon: Images.hunger },
  { id: 10, name: "Medical", icon: Images.medical },
  { id: 11, name: "Diy", icon: Images.diy },
  { id: 12, name: "Women", icon: Images.women },
  { id: 13, name: "Temples", icon: Images.temples },
  { id: 14, name: "Community", icon: Images.community },
];

const CampaignSideBar = ({ selectedCategory, setSelectedCategory }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ≤600px
  const isAbove1200 = useMediaQuery("(min-width:750px)");

  return (
    <Box
      sx={{
        maxWidth: isAbove1200 ? "156px" : "100%", // 750px only above 1200
        background: "#fff",
        borderRadius: isMobile ? "10px" : "20px",
        px: "6px", // left & right stay 6px
        py: isMobile ? "6px" : "20px",
        display: "flex",
        flexDirection: isMobile ? "row" : "column", // row on mobile, column otherwise
        flexWrap: isMobile ? "nowrap" : "wrap", // wrap on mobile
        gap: "8px",
        overflowX: isMobile ? "auto" : "visible", // ✅ scroll on mobile
        whiteSpace: isMobile ? "nowrap" : "normal", // ✅ no wrapping on mobile
        "&::-webkit-scrollbar": { display: "none" }, // ✅ hide scrollbar
        scrollbarWidth: "none", // ✅ hide scrollbar (Firefox)
      }}
    >
      {categories.map((cat) => (
        <Box
          key={cat.id}
          onClick={() => setSelectedCategory(cat.name)}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            cursor: "pointer",
            px: "10px",
            py: "14px",
            borderRadius: "6px",
            backgroundColor: selectedCategory === cat.name ? "#F04951" : "#fff",
            color: selectedCategory === cat.name ? "#fff" : "#4A4A49",
            // fontFamily: "Red Hat Display",
            fontSize: "12px",
            fontWeight: 500,
            transition: "all 0.2s ease",
            flex: isMobile ? "0 0 auto" : "1",
            minWidth: isMobile ? "auto" : "100%",
            textAlign: "center",
          }}
        >
          <img
            src={cat.icon}
            alt={cat.name}
            style={{
              width: "20px",
              height: "20px",
              filter:
                selectedCategory === cat.name
                  ? "brightness(0) invert(1)" // make white if active
                  : "none",
            }}
          />
          {cat.name}
        </Box>
      ))}
    </Box>
  );
};

export default CampaignSideBar;
